var map = {
  "./ru-RU.cjs": [
    "80770",
    9,
    "8835"
  ],
  "./es-ES.cjs": [
    "34560",
    9,
    "9293"
  ],
  "./en-CA.cjs": [
    "59563",
    9,
    "8360"
  ],
  "./fr-FR.cjs": [
    "1124",
    9,
    "2869"
  ],
  "./en-US.cjs": [
    "56315",
    9,
    "9156"
  ],
  "./es-AR.cjs": [
    "51229",
    9,
    "1938"
  ],
  "./ja-JP.cjs": [
    "21083",
    9,
    "7852"
  ],
  "./de-DE.cjs": [
    "96526",
    9,
    "7179"
  ],
  "./ko-KR.cjs": [
    "78013",
    9,
    "270"
  ],
  "./th-TH.cjs": [
    "10774",
    9,
    "2801"
  ],
  "./common/index.cjs": [
    "57973",
    7,
    "8718"
  ],
  "./id-ID.cjs": [
    "24942",
    9,
    "2307"
  ],
  "./en-GB.cjs": [
    "48692",
    9,
    "2881"
  ],
  "./pt-BR.cjs": [
    "82984",
    9,
    "8781"
  ],
  "./it-IT.cjs": [
    "71726",
    9,
    "1251"
  ],
  "./es-419.cjs": [
    "27258",
    9,
    "1769"
  ],
  "./en-IN.cjs": [
    "46322",
    9,
    "8723"
  ],
  "./hi-IN.cjs": [
    "62546",
    9,
    "979"
  ],
  "./en-AU.cjs": [
    "28121",
    9,
    "8666"
  ],
  "./tr-TR.cjs": [
    "50576",
    9,
    "3957"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[2]).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 43976;
module.exports = __rspack_async_context;
